import styled from 'styled-components'

import { Form } from 'antd'

export const FormItemFlex = styled(Form.Item)`
  .ant-form-item-control-input-content {
    display: flex;
    justify-content: space-between;
  }
`

export const FormContainer = styled.div`
  margin: 0 auto;
  width: 28rem;
  max-width: 90vw;
  position: relative;
  z-index: 2;
  background-color: #ffffff;
  border-radius: 12px;
  box-shadow: 0 25px 50px -12px rgba(0, 0, 0, 0.15);
`

export const FormWrapper = styled.div`
  padding: 48px 40px;
`

export const FormTitle = styled.h2`
  margin: 0px 0px 8px 0px;
  color: #111827;
  font-size: 2.5rem;
  font-weight: 700;
  text-align: center;
`

export const FormSubtitle = styled.p`
  color: #4B5563;
  font-size: 0.875rem;
  margin-bottom: 2rem;
  text-align: center;
`

export const StyledForm = styled(Form)`
  .ant-input-affix-wrapper {
    background: #F9FAFB !important;
    border: 1px solid #D1D5DB !important;
    border-radius: 6px !important;

    .ant-input {
      background: transparent !important;
      color: #111827 !important;
      border: none !important;

      &::placeholder {
        color: #9CA3AF !important;
      }
    }

    .ant-input-prefix {
      color: #9CA3AF !important;
    }

    &:hover, &:focus, &.ant-input-affix-wrapper-focused {
      border-color: hsl(33, 100%, 50%) !important;
      box-shadow: 0 0 0 2px rgba(250, 118, 255, 0.1) !important;
    }
  }

  .ant-input-password {
    background: #F9FAFB !important;
    border: 1px solid #D1D5DB !important;
    border-radius: 6px !important;

    .ant-input {
      background: transparent !important;
      color: #111827 !important;
      border: none !important;

      &::placeholder {
        color: #9CA3AF !important;
      }
    }

    .ant-input-prefix {
      color: #9CA3AF !important;
    }

    &:hover, &:focus, &.ant-input-password-focused {
      border-color: hsl(33, 100%, 50%) !important;
      box-shadow: 0 0 0 2px rgba(250, 118, 255, 0.1) !important;
    }
  }

  .ant-btn-primary {
    background: hsl(33, 100%, 50%) !important;
    border-color: hsl(33, 100%, 50%) !important;
    color: white !important;
    font-weight: 600 !important;
    text-transform: uppercase !important;
    font-size: 0.875rem !important;
    height: 48px !important;
    border-radius: 6px !important;

    &:hover {
      background: hsl(33, 100%, 45%) !important;
      border-color: hsl(33, 100%, 45%) !important;
    }
  }

  .ant-checkbox-wrapper {
    color: #4B5563 !important;

    .ant-checkbox {
      .ant-checkbox-inner {
        background: white !important;
        border-color: #D1D5DB !important;
      }

      &.ant-checkbox-checked .ant-checkbox-inner {
        background: hsl(33, 100%, 50%) !important;
        border-color: hsl(33, 100%, 50%) !important;
      }
    }
  }

  .ant-btn:not(.ant-btn-primary) {
    background: white !important;
    border: 1px solid #D1D5DB !important;
    color: #4B5563 !important;
    height: 48px !important;
    border-radius: 6px !important;

    &:hover {
      border-color: hsl(33, 100%, 50%) !important;
      color: hsl(33, 100%, 50%) !important;
    }
  }

  .ant-divider {
    border-top-color: #E5E7EB !important;
    .ant-divider-inner-text {
      color: #9CA3AF !important;
    }
  }
`

export const PageContainer = styled.div`
  background-image: url('/authbgimage.png');
  background-size: cover;
  background-position: center;
  background-repeat: no-repeat;
  display: flex;
  align-items: center;
  justify-content: center;
  width: 100vw;
  height: 100vh;
  position: relative;

  /* Gradient colour overlay on top of the photo */
  &::before {
    content: '';
    position: absolute;
    inset: 0;
    background: linear-gradient(
      135deg,
      hsla(210, 55%, 22%, 0.88) 0%,
      hsla(210, 70%, 15%, 0.92) 100%
    );
    pointer-events: none;
  }
`
